import { render, staticRenderFns } from "./select-list-limit.vue?vue&type=template&id=0888f932&scoped=true&"
import script from "./select-list-limit.vue?vue&type=script&lang=js&"
export * from "./select-list-limit.vue?vue&type=script&lang=js&"
import style0 from "./select-list-limit.vue?vue&type=style&index=0&id=0888f932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888f932",
  null
  
)

export default component.exports